




















import { Vue } from 'vue-property-decorator';
import store from '@/store';
import { SNACK_ACTION, SnackBarState } from '@/store/snackbar';

const Component = Vue.extend({
  methods: {
    closeSnackbar() {
      store.dispatch(SNACK_ACTION.CLEAR);
    },
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar as SnackBarState;
    },
  },
});

export default Component;
